/**
 * Static milestone definitions (B-2026-0075).
 *
 * Mirrors backend/app/config/milestones_config.py.
 * Used by MilestoneCelebrationToast to resolve labels and icons from
 * ``newly_awarded_milestones[]`` in the eval response metadata without
 * an extra API call.
 *
 * IMPORTANT: Keep in sync with milestones_config.py when adding new milestones.
 */

export interface MilestoneDefinition {
  id: string;
  label: string;
  description: string;
  icon_key: string;
  requirement: string;
  is_private: boolean;
}

export const MILESTONE_DEFINITIONS: MilestoneDefinition[] = [
  {
    id: 'first_eval',
    label: 'First Steps',
    description: 'You completed your very first evaluation.',
    icon_key: '🎯',
    requirement: 'Complete your first evaluation.',
    is_private: false,
  },
  {
    id: 'eval_5',
    label: 'Getting Into It',
    description: 'You submitted 5 evaluations. The reps are adding up.',
    icon_key: '🔥',
    requirement: 'Submit 5 evaluations.',
    is_private: false,
  },
  {
    id: 'eval_25',
    label: 'Committed',
    description: '25 evaluations in. Real dedication.',
    icon_key: '⚡',
    requirement: 'Submit 25 evaluations.',
    is_private: false,
  },
  {
    id: 'eval_100',
    label: 'Century Club',
    description: '100 evaluations. You are a serious athlete.',
    icon_key: '💯',
    requirement: 'Submit 100 evaluations.',
    is_private: false,
  },
  {
    id: 'first_pb',
    label: 'Personal Best',
    description: 'You achieved a new personal best score on a template.',
    icon_key: '🏆',
    requirement: 'Beat your previous best score on any template.',
    is_private: false,
  },
  {
    id: 'score_70',
    label: 'Over 70',
    description: 'You scored 70 or above on an evaluation.',
    icon_key: '🌟',
    requirement: 'Score 70 or above on any evaluation.',
    is_private: false,
  },
  {
    id: 'score_80',
    label: 'Over 80',
    description: 'Excellent form — you scored 80 or above.',
    icon_key: '✨',
    requirement: 'Score 80 or above on any evaluation.',
    is_private: false,
  },
  {
    id: 'score_90',
    label: 'Elite Form',
    description: 'Near-perfect execution — you scored 90 or above.',
    icon_key: '🥇',
    requirement: 'Score 90 or above on any evaluation.',
    is_private: false,
  },
  {
    id: 'streak_3',
    label: '3-Week Streak',
    description: 'You submitted evaluations in 3 consecutive calendar weeks.',
    icon_key: '📅',
    requirement:
      'Submit at least one evaluation per week for 3 consecutive weeks (Mon–Sun UTC).',
    is_private: true,
  },
  {
    id: 'streak_7',
    label: '7-Week Streak',
    description: 'Seven consecutive weeks of consistent training. Incredible.',
    icon_key: '🗓️',
    requirement:
      'Submit at least one evaluation per week for 7 consecutive weeks (Mon–Sun UTC).',
    is_private: true,
  },
  {
    id: 'template_master',
    label: 'Template Master',
    description: 'You completed 10 or more evaluations on a single template.',
    icon_key: '🎓',
    requirement: 'Complete 10 evaluations on the same template.',
    is_private: false,
  },
];
